import { render, staticRenderFns } from "./backoffice-power-bi.vue?vue&type=template&id=0f94ad8b&scoped=true"
import script from "./backoffice-power-bi.vue?vue&type=script&lang=ts"
export * from "./backoffice-power-bi.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-power-bi.vue?vue&type=style&index=0&id=0f94ad8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94ad8b",
  null
  
)

export default component.exports